import { useEffect } from "react";

export const ThemeDetector = ({
  onHandleThemeChange,
}: {
  onHandleThemeChange: Function;
}) => {
  useEffect(() => {
    const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
    const handleThemeChange = (e: any) => {
      onHandleThemeChange(
        window.matchMedia("(prefers-color-scheme: dark)").matches
          ? "dark"
          : "light"
      );
    };
    mediaQuery.addEventListener("change", handleThemeChange);
    return () => {
      mediaQuery.removeEventListener("change", handleThemeChange);
    };
  }, [onHandleThemeChange]);
  return <></>;
};
